var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.776 24.7138C26.0262 23.4636 26.7286 21.7679 26.7286 19.9998C26.7286 18.2317 26.0262 16.536 24.776 15.2858C23.5257 14.0355 21.83 13.3331 20.0619 13.3331C18.2938 13.3331 16.5981 14.0355 15.3479 15.2858C14.0976 16.536 13.3953 18.2317 13.3953 19.9998C13.3953 21.7679 14.0976 23.4636 15.3479 24.7138C16.5981 25.9641 18.2938 26.6665 20.0619 26.6665C21.83 26.6665 23.5257 25.9641 24.776 24.7138Z",
    fill: "white",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7285 33.44C23.8068 34.8895 20.4924 35.3474 17.2873 34.7441C14.0821 34.1408 11.1609 32.5094 8.96619 30.0969C6.77148 27.6844 5.42286 24.6223 5.12463 21.3746C4.8264 18.1268 5.59482 14.8703 7.31347 12.0985C9.03212 9.32663 11.6074 7.19045 14.649 6.01357C17.6907 4.83669 21.0331 4.68323 24.1698 5.57643C27.3066 6.46964 30.0667 8.36085 32.0321 10.9635C33.9976 13.5662 35.0612 16.7386 35.0618 20V22.5C35.0618 23.6051 34.6228 24.6649 33.8414 25.4463C33.06 26.2277 32.0002 26.6667 30.8951 26.6667C29.79 26.6667 28.7302 26.2277 27.9488 25.4463C27.1674 24.6649 26.7285 23.6051 26.7285 22.5V13.3334M26.7285 20C26.7285 21.7681 26.0261 23.4638 24.7758 24.7141C23.5256 25.9643 21.8299 26.6667 20.0618 26.6667C18.2937 26.6667 16.598 25.9643 15.3477 24.7141C14.0975 23.4638 13.3951 21.7681 13.3951 20C13.3951 18.2319 14.0975 16.5362 15.3477 15.286C16.598 14.0357 18.2937 13.3334 20.0618 13.3334C21.8299 13.3334 23.5256 14.0357 24.7758 15.286C26.0261 16.5362 26.7285 18.2319 26.7285 20Z",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ed3af91c39d6665439e866da2f9075bb.svg";
export { ForwardRef as ReactComponent };